<div class="seat-accrd open">
    <div class="seat-accrd-header">
        <div class="seat-accrd-header-inner">
            <div class="title-text">
                <span>
                    {{ flightLeg.segments[0].departing_at.IS08601DateTime? flightLeg.segments[0].departing_at.day +" "+
                    flightLeg.segments[0].departing_at.date +" "+
                    flightLeg.segments[0].departing_at.month:flightLeg.segments[0].departing_at | date: 'EEEE, MMMM
                    yyyy' }}
                    &nbsp;&nbsp;•&nbsp;&nbsp;<span *ngIf="inbound">{{'flightsPage.common.inbound'| i18n}}</span><span *ngIf="outbound">{{'flightsPage.common.outbound'| i18n}}</span>
                </span>
            </div>
        </div>

    </div>
    <div class="seat-accrd-body">
        <div class="accordion-toggle">
            <div class="timings">
                <div class="origin">
                    <div class="logo">
                        <img width="30" height="30" class="airline-logo"
                            [src]="flightLeg.segments[0].marketing_carrier.logo_symbol_url" alt="">
                    </div>
                    <div class="airline-info">
                        <p matTooltip="{{ flightLeg.segments[0].origin.name }}" class="tooltip">{{ flightLeg.segments[0].origin.iata_code }}</p>
                        <p>{{ flightLeg.segments[0].departing_at.time?flightLeg.segments[0].departing_at.time:
                            this.getTimeFromDate(flightLeg.segments[0].departing_at) }}</p>
                    </div>
                </div>
                <span></span>
                <div>
                    <p class="total-time">{{this.checkType(flightLeg.duration)?
                        parseDuration(flightLeg.duration):extractDurationComponents(flightLeg.duration) }}</p>
                    <p matTooltip="{{ getStopsTooltipText(flightLeg.segments) }}" class="stop">{{ organizeNumberOfStops(flightLeg.segments.length -1 , 'flightsPage.result.stops' |
                        i18n )}}</p>

                </div>
                <span></span>

                <div class="destination">
                    <div>
                        <p matTooltip="{{ flightLeg.segments[flightLeg.segments.length - 1].destination.name }}" class="tooltip">{{ flightLeg.segments[flightLeg.segments.length - 1].destination.iata_code }}</p>
                        <p>{{ flightLeg.segments[flightLeg.segments.length - 1].arriving_at.time ?
                            flightLeg.segments[flightLeg.segments.length - 1].arriving_at.time :
                            this.getTimeFromDate(flightLeg.segments[flightLeg.segments.length - 1].arriving_at)}}</p>
                    </div>
                    <p matTooltip="Days difference" *ngIf="flightLeg.daysDifference > 0" class="dayDiff">+ {{ flightLeg.daysDifference }}</p>
                 </div>
            </div>
            <div #accrd *ngIf=" flightLeg.segments.length > 1 " class="accrd-icon"
                (click)="toggleClassToClosestParent()">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path d="M18.8105 15L12.0605 8.25L5.31055 15" stroke="black" stroke-width="1.5"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>
        </div>
        <div class="flight-data" #toggle *ngIf=" flightLeg.segments.length > 1 ">
            <div class="departure-arrival-desktop">
                <div class="departure-arrival" *ngFor="let stop of flightLeg.segments">
                    <div class="origin">
                        <div class="logo">
                            <img width="30" height="30" class="airline-logo"
                                [src]="stop.marketing_carrier.logo_symbol_url" alt="">
                        </div>
                        <div class="airline-info">
                            <p matTooltip="{{ stop.origin.name }}" class="tooltip">{{ stop.origin.iata_code }}</p>
                            <p>{{ stop.departing_at.time?stop.departing_at.time:getTimeFromDate(stop.departing_at) }}
                            </p>
                        </div>
                    </div>
                    <div class="stop-col">
                        <p>{{this.checkType(stop.duration)?
                            parseDuration(stop.duration):extractDurationComponents(stop.duration) }}</p>
                        <span></span>
                    </div>
                    <div class="destination">
                        <div> 
                        <p matTooltip="{{ stop.destination.name }}" class="tooltip">{{ stop.destination.iata_code }}</p>
                        <p>{{ stop.arriving_at.time?stop.arriving_at.time:getTimeFromDate(stop.arriving_at) }}</p>
                        </div>
                        <p matTooltip="Days difference" *ngIf="flightLeg.daysDifference > 0 && stop.destination.iata_code == flightLeg.segments[flightLeg.segments.length - 1].destination.iata_code" class="dayDiff">+ {{ flightLeg.daysDifference }}</p>
                    </div>
                </div>
                <div class="departure-arrival-timing">
                    <p><span>Arrives:</span>
                        {{flightLeg.segments[0].arriving_at.IS08601DateTime?this.getDayMonthYear(flightLeg.segments[0].arriving_at.IS08601DateTime):this.getDayMonthYear(flightLeg.segments[flightLeg.segments.length
                        - 1].arriving_at)}}</p>
                    <span></span>
                    <p><span>Journey duration:</span> {{this.checkType(flightLeg.duration)?
                        parseDuration(flightLeg.duration):extractDurationComponents(flightLeg.duration) }}</p>
                </div>
            </div>
            <!-- <div class="departure-arrival-mobile">
                <div class="departure-arrival" *ngFor="let stop of stopObj">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="66" viewBox="0 0 12 66" fill="none">
                    <line opacity="0.11" x1="5.44179" y1="54.498" x2="5.44179" y2="11.498" stroke="black" stroke-width="1.11643"/>
                    <circle cx="5.58214" cy="6.08018" r="5.02392" fill="white" stroke="#C8C8C8" stroke-width="1.11643"/>
                    <circle cx="5.58214" cy="60.0802" r="5.02392" fill="white" stroke="#C8C8C8" stroke-width="1.11643"/>
                    </svg>
                    <div>
                        <div class="dept">
                            <p class="depature">{{ stop.source.departingTime }} {{ stop.source.iataCode }}</p>
                            <p><span>Arrives:</span> {{flightLeg.segments[0].arriving_at.IS08601DateTime?this.getDayMonthYear(flightLeg.segments[0].arriving_at.IS08601DateTime):this.getDayMonthYear(flightLeg.segments[flightLeg.segments.length - 1].arriving_at)}}</p>
                        </div>
                        <span></span>
                        <div class="arr">
                            <p class="arrival">{{ stop.destination.arrivingTime }} {{ stop.destination.iataCode }}</p>
                            <p>
                            <span>Journey duration:</span> 
                            {{flightLeg.duration?
                                checkType(flightLeg.duration)?
                                parseDuration(flightLeg.duration) :
                                this.extractDurationComponents(flightLeg.duration)
                                :''
                            }}
                            </p>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</div>